import styled from 'styled-components';
import { outlineGray } from '../../../config/colors';
import { ReactComponent as $DeckSvg10 } from '../../../resources/deck10.svg';
import { ReactComponent as $DeckSvg11 } from '../../../resources/deck11.svg';
import { ReactComponent as $DeckSvg12 } from '../../../resources/deck12.svg';
import { TILE_WIDTH } from './consts';

export const Wrapper = styled.div`
  position: relative;
  margin: 2rem auto;
  width: fit-content;
`;

export const DeckSvg10 = styled($DeckSvg10)`
  width: 939px;
  height: 238px;
`;

export const DeckSvg11 = styled($DeckSvg11)`
  width: 1004px;
  height: 238px;
`;

export const DeckSvg12 = styled($DeckSvg12)`
  width: 1079px;
  height: 238px;
`;

export const BigBox = styled.div`
  width: ${5 * TILE_WIDTH}px;
  height: 85px;
  outline: 1px solid gainsboro;
  background-color: white;
  :hover {
    cursor: pointer;
    background-color: lightgreen;
  }
`;

export const SmallBox = styled.div`
  width: ${5 * TILE_WIDTH}px;
  height: 30px;
  outline: 1px solid gainsboro;
  background-color: white;
  :hover {
    cursor: pointer;
    background-color: lightgreen;
  }
`;

export const BoxesWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: ${5 * TILE_WIDTH}px;
  top: 40px;
  left: 124px;
  > div:not(last-of-type) {
    margin-bottom: 5px;
  }
`;

export const TileCounter = styled.div`
  width: ${({nrOfModules}) => `${(nrOfModules - 1) * 5 * TILE_WIDTH}px`};
  position: absolute;
  left: 124px; 124
  bottom: -30px;
  display: flex;
  justify-content: space-between;
`;

export const CounterElement = styled.div`
  position: relative;

  ::before {
    content: '';
    position: absolute;
    transform: translate(75%, -100%);
    border-left: 1px solid gainsboro;
    height: 75px;
  }
  :first-of-type {
    ::before {
      transform: translate(0, -100%);
    }
  }
`;

export const CounterElementInner = styled.div`
  position: absolute;
  transform: translateX(-50%);
  color: gainsboro;
`;
